import { logIntoIDM, getPermissions } from '@/api'

const module = 'IDM_MODULE_'

export const SIGN_INTO_IDM = module + 'SIGN_INTO_IDM'
export const REFRESH_IDM_TOKEN = module + 'REFRESH_IDM_TOKEN'
export const GET_ALL_PERMISSIONS = module + 'GET_ALL_PERMISSIONS'

const actions = {
  [SIGN_INTO_IDM](context, userinfo) {
    return logIntoIDM(userinfo.username, userinfo.password).then(resp => {
      context.commit(SIGN_INTO_IDM, resp)
      return true
    })
  },
  [GET_ALL_PERMISSIONS](context) {
    getPermissions().then(resp => {
      context.commit(GET_ALL_PERMISSIONS, resp.data)
    })
  },
  [REFRESH_IDM_TOKEN](context, refreshInfo) {
    context.commit(REFRESH_IDM_TOKEN, refreshInfo)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/store/modules/idmAuth/actions.js